import { Skeleton, styled } from '@mui/material';

const Grid = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr 1fr',
  height: '400px',
  margin: theme.spacing(4, 0, 1, 0),
}));

const Subgrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateRows: '1fr 2fr',
}));

const RightAligned = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});

type Props = React.HTMLAttributes<HTMLDivElement>;

export const DefaultScreenSkeleton: React.FC<Props> = (props) => (
  <div {...props}>
    <Skeleton height={50} />
    <Skeleton width={300} />
    <Skeleton width={200} />
    <Grid>
      <Skeleton height="100%" variant="rounded" />
      <Subgrid>
        <Skeleton height="100%" variant="rounded" />
        <Skeleton height="100%" variant="rounded" />
      </Subgrid>
    </Grid>
    <RightAligned>
      <Skeleton width={200} />
    </RightAligned>
  </div>
);
